import script from "./card-bg-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./card-bg-item.vue?vue&type=script&lang=ts&setup=true"

import "./card-bg-item.vue?vue&type=style&index=0&id=36e014d8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e014d8"]])

export default __exports__